module.exports = __webpack_public_path__ + "img/text.2225a4c3.png";